/* eslint-disable react/no-danger */
import React, { useEffect } from 'react';
import { useT } from 'talkr';
import steps from '../../../survey/steps';
import s from './index.module.scss';
import questions from '../../../survey/questions';
import common from '../../index.module.scss';

import img from './img/img.png';

function Habbits () {
	const { T } = useT();
	useEffect(() => {
		steps.setStepStatus({
			stepName: 'habbits',
			stepStatus: true
		});
	}, []);

	const descriptionValue = questions.getAnswers({ questionName: 'duration' })[Object.keys(questions.getAnswers({ questionName: 'duration' }))[0]];
	let description = T('habbits_description_normal');

	switch (descriptionValue?.value) {
	case 'minimum':
		description = T('habbits_description_minimum');
		break;
	case 'normal':
		description = T('habbits_description_normal');
		break;
	case 'maximum':
		description = T('habbits_description_maximum');
		break;
	default:
		description = T('habbits_description_normal');
	}

	return (
		<div className={`${common.step} ${s.habbits}`}>
			<h1 className={common.stepTitle}>
				{T('habbits_title')}
			</h1>
			<div className={s.container}>
				<div className={s.imgWrapper}>
					<img className={s.img} src={img} alt="" />
				</div>
				<h2 className={s.subTitle}>{T('habbits_sub_title')}</h2>
				<div className={s.description} dangerouslySetInnerHTML={{ __html: description }} />
			</div>
		</div>
	);
}

export default Habbits;
